import { Component, Input } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ErrorCodes } from '../../../../../shared/enum/api-errors';

@Component({
  selector: 'payment-details',
  templateUrl: './details.component.html',
  styleUrls: [ './details.component.scss' ]
})
export class AdminPaymentDetailsComponent {

  @Input() row: any;
  @Input() dateFilterYear: string;
  @Input() dateFilterMonth: string;

  public customInvoiceAmount: string;
  invoiceCalculation: any = null;
  isToggled: boolean = false;
  invoiceDetails: any = {};
  recalcSubscription: Subscription;
  generateSubscription: Subscription;
  chargeSubscription: Subscription;

  constructor(private httpClient: HttpClient,
              private toastrService: ToastrService) {
  }

  showDetails() {
    this.isToggled = !this.isToggled;
    if (this.isToggled) {
      this.calculate();
      this.getInvoiceDetails();
    }
  }

  calculate(): void {
    const params = new HttpParams()
      .set('dateFilterYear', this.dateFilterYear)
      .set('dateFilterMonth', this.dateFilterMonth)
      .set('customInvoiceAmount', this.customInvoiceAmount)
    ;
    const url = this.getInvoiceCalculationUrl();
    this.recalcSubscription = this.httpClient.get<any>(url, { params: params }).subscribe(
      (response: any) => {
        if (response) {
          this.invoiceCalculation = response;
        }
        return response;
      }, (error: HttpErrorResponse) => {
        this.toastrService.error(error.error ? (error.error.code || 'Something went wrong...') : 'Error');
        return error;
      });
  }

  getInvoiceDetails() {
    if (!this.row.moneybirdInvoiceId) {
      return;
    }
    this.httpClient.get(`/admin/payment/${this.row.customerId}/invoice/${this.row.invoiceId}`)
      .subscribe((invoice: any) => {
        this.invoiceDetails = invoice;
      });
  }

  generateInvoice(): any {
    const url = this.getInvoiceGenerationUrl();
    const body = {
      dateFilterYear: this.dateFilterYear,
      dateFilterMonth: this.dateFilterMonth,
      customInvoiceAmount: this.customInvoiceAmount,
    };
    this.generateSubscription = this.httpClient.post<any>(url, body).subscribe((response: any) => {
      if (response) {
        this.row.invoiceId = response.id;
        this.row.invoiceUrl = response.url;
        this.row.moneybirdInvoiceId = response.moneybirdInvoiceId;
        this.getInvoiceDetails();
        this.toastrService.success('Generated');
      }
    }, (error: HttpErrorResponse) => {
      this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
    });
  }

  charge(): any {
    const url = this.getChargeForInvoiceUrl();
    this.chargeSubscription = this.httpClient.post<any>(url, {}).subscribe(
      (response: any) => {
        if (response) {
          this.row.invoicePaymentId = response.invoice.id;
          this.row.paymentId = response.payment.id;
        }
        this.toastrService.success('Charged');
        return response;
      }, (error: HttpErrorResponse) => {
        this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
        return error;
      });
  }

  getInvoiceCalculationUrl(): string {
    return `/admin/payment${this.row.customerId ? '/' + this.row.customerId + '/calculate-price' : ''}`;
  }

  getInvoiceGenerationUrl(): string {
    return `/admin/payment${this.row.customerId ? '/' + this.row.customerId + '/generate-invoice' : ''}`;
  }

  getChargeForInvoiceUrl(): string {
    return `/admin/payment${this.row.invoiceId ? '/' + this.row.invoiceId + '/charge-for-invoice' : ''}`;
  }
}
